<div class="w-full md:max-w-md md:mt-0 xl:p-0 md:ml-auto">
  <div class="py-6 md:p-6">
    <h2 class="text-xl text-green-800 font-semibold">
      {{ 'Forgot Password or Unlock Account' | translate }}
    </h2>
    <div class="py-2"></div>
    <ng-container *ngIf="!isUserTypeLoaded">
      <flowbite-loading size="1.25rem"></flowbite-loading>
    </ng-container>
    <ng-container *ngIf="isUserTypeLoaded">
      <div [formGroup]="form1" *ngIf="isStep1">
        <div>
          <div *ngIf="userType == 'company'" class="font-medium mb-2">{{ 'Please enter the email address' | translate }}{{ ' that used during registration.' | translate }}</div>
          <div *ngIf="userType != 'company'" class="font-medium mb-2">{{ 'Please enter the email address or phone number ' | translate }}<span class="text-gray-500">{{ '(either one)' | translate }}</span>{{ ' that used during registration.' | translate }}</div>
          <div
            class="flex flex-row flex-nowrap h-10 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-primary-600 focus:border-primary-600 block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
              <input
                type="email"
                name="account"
                id="account"
                class="flex-grow px-2.5 border-none focus:outline-none focus:ring-0 bg-transparent"
                formControlName="account"
                autofocus
                (keydown.enter)="onSubmitForgotPasswordStep1()"
              />
          </div>

          <p
            class="mt-1 text-xs text-red-600 dark:text-red-500"
            *ngIf="(form1.controls.account?.errors?.['emailformat']) && (form1.controls.account?.touched ?? false)"
          >
            <ng-container *ngIf="userType != 'company'">{{ 'Email address or phone number format is incorrect' | translate }}</ng-container>
            <ng-container *ngIf="userType == 'company'">{{ 'Email address format is incorrect' | translate }}</ng-container>
          </p>
          <p
            class="mt-1 text-xs text-red-600 dark:text-red-500"
            *ngIf="(form1.controls.account?.errors?.['required']) && isStep1SubmitAttempted"
          >
            {{ 'This field is required' | translate }}
          </p>
        </div>

        <button
          type="submit"
          class="mt-8 flex flex-row justify-center w-60 m-auto focus:outline-none focus:ring-notus-primary-300 rounded-sm text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
          (click)="onSubmitForgotPasswordStep1()"
          [class]="
            isLoading
              ? 'bg-white ring-notus-primary-700 ring-2 cursor-default'
              : 'bg-notus-primary-700 hover:bg-notus-primary-800'
          "
        >
          <ng-container *ngIf="!isLoading">
            {{ 'Next' | translate }}
          </ng-container>
          <ng-container *ngIf="isLoading">
            <flowbite-loading size="1.25rem"></flowbite-loading>
          </ng-container>
        </button>


        <div class="text-center mt-4">
          <div class="">
            <p
              class="text-sm font-light text-gray-500 dark:text-gray-400 text-center"
            >
              <a
                href="https://wcms.cic.hk/content/dam/one-pass/onepass-user-manual.pdf"
                class="text-gray-700 hover:underline dark:text-primary-600 cursor-pointer underline underline-offset-4 text-xs"
                target="_blank"
                >{{ 'User Manual' | translate }}</a
              >
            </p>
          </div>
        </div>


        <div class="text-center mt-4">
          <div class="">
            <p
              class="text-sm font-light text-gray-500 dark:text-gray-400 text-center"
            >
              <a
                (click)="onBackToLogin($event)"
                class="text-notus-primary-700 hover:underline dark:text-primary-600 cursor-pointer underline underline-offset-4 text-xs"
                >{{ 'Back to login' | translate }}</a
              >
            </p>
          </div>
        </div>
      </div>
      <div [formGroup]="form2" *ngIf="!isStep1">
        <div class="font-medium mb-2">{{ 'To protect your account security, please enter one of the following details:' | translate }}</div>
        <ul *ngIf="userType != 'company'" class="list-disc pl-5 mb-2 font-normal text-sm">
          <li *ngIf=" isStep1AccountEmail">{{ 'Phone number' | translate }}</li>
          <li *ngIf="!isStep1AccountEmail">{{ 'Email Address' | translate }}</li>
          <li>{{ 'Name in Chinese' | translate }}{{ 'Name in Chinese input sample' | translate }}</li>
          <li>{{ 'Name in English' | translate }}{{ 'Name in English input sample' | translate }}</li>
          <li>{{ 'Worker ID' | translate }}{{ 'Worker ID input sample' | translate }}</li>
        </ul>
        <ul *ngIf="userType == 'company'" class="list-disc pl-5 mb-2 font-normal text-sm">
          <li>{{ 'Chinese Company Name' | translate }}</li>
          <li>{{ 'English Company Name' | translate }}</li>
          <li>{{ 'e-Tendering System Supplier ID (You can refer to the initial registration email)' | translate }}</li>
        </ul>
        <div
          class="flex flex-row flex-nowrap items-stretch h-10 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-primary-600 focus:border-primary-600 w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        >
            <input
              type="email"
              name="verification"
              id="verification"
              formControlName="verification"
              class="flex-grow px-2.5 border-none focus:outline-none focus:ring-0 bg-transparent"
              #verificationInput
              (keydown.enter)="onSubmitForgotPassword()"
            />
        </div>

        <p
          class="mt-1 text-xs text-red-600 dark:text-red-500"
          *ngIf="
            (form2.controls.verification?.errors?.['required']) &&
            isStep2SubmitAttempted
          "
        >
          {{ 'Required Field' | translate }}
        </p>

        <button
          type="submit"
          class="mt-8 flex flex-row justify-center w-60 m-auto focus:outline-none focus:ring-notus-primary-300 rounded-sm text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
          (click)="onSubmitForgotPassword()"
          [class]="
            isLoading
              ? 'bg-white ring-notus-primary-700 ring-2 cursor-default'
              : 'bg-notus-primary-700 hover:bg-notus-primary-800'
          "
        >
          <ng-container *ngIf="!isLoading">
            {{ 'Reset Password' | translate }}
          </ng-container>
          <ng-container *ngIf="isLoading">
            <flowbite-loading size="1.25rem"></flowbite-loading>
          </ng-container>
        </button>


        <div class="text-center mt-4">
          <div class="">
            <p
              class="text-sm font-light text-gray-500 dark:text-gray-400 text-center"
            >
              <a
                href="https://wcms.cic.hk/content/dam/one-pass/onepass-user-manual.pdf"
                class="text-gray-700 hover:underline dark:text-primary-600 cursor-pointer underline underline-offset-4 text-xs"
                target="_blank"
                >{{ 'User Manual' | translate }}</a
              >
            </p>
          </div>
        </div>


        <div class="text-center mt-4">
          <div class="">
            <p
              class="text-sm font-light text-gray-500 dark:text-gray-400 text-center"
            >
              <a
                (click)="onBackToLogin($event)"
                class="text-notus-primary-700 hover:underline dark:text-primary-600 cursor-pointer underline underline-offset-4 text-xs"
                >{{ 'Back to login' | translate }}</a
              >
            </p>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
